<template>
  <div class="container">
    <el-row :gutter="10" class="header">
     <el-button type="text" @click="handleSelect('backDataAccSummary')" :class="currentRouter ===
     'backDataAccSummary'? 'active' : ''">准确率概览</el-button>
     <el-button type="text" :class="currentRouter ===
     'backDataAccByCanteen'? 'active' : ''" @click="handleSelect('backDataAccByCanteen')">准确率查询</el-button>
    </el-row>
    <el-row :gutter="10">
      <el-form ref="form" :inline="true">
        <el-form-item label="日期">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            placeholder="选择日期"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            :clearable="false"
            size="mini"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="准确率红线">
          <el-input
            size="mini"
            v-model="acc_line"
            placeholder="请输入准确率标准"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="getDishAccList">查询</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row :gutter="10">
      <!--<el-col :span="12" v-for="">-->
      <!--<zxEchart></zxEchart>-->
      <!--</el-col>-->
      <el-col :span="8" v-for="(item, idx) in acc_list_sort" :key="idx">
        <echartGetDish :item="item" class="chart-item" :acc_line="acc_line"></echartGetDish>
      </el-col>
      <h3></h3>
    </el-row>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import util from '@/lib/util';
import moment from 'moment';
import echartGetDish from './echartGetDish';
import {apiGetResentlyAcc} from '@/api';

export default {
  name: "backDataAccSummary",
  components: {
    echartGetDish
  },
  data() {
    return {
      acc_line: 98,
      dateList: [],
      dateRange: [
        new Date(new Date().getTime() - 3600 * 24 * 7 * 1000),
        new Date()
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.setSubTitle("准确率概览");
    this.getDishAccList();
  },
  methods: {
    ...mapMutations(["setSubTitle"]),
    handleSelect(tab) {
      // console.log(tab, event);
      console.log(tab);
      // console.log(tab);

      this.$router.push({
        name: tab
      });
    },
    async getDishAccList() {
      this.dateList = [];
      let res = await apiGetResentlyAcc({
        ...this.dateRank,
        acc_line: (this.acc_line / 100).toString()
      });
      this.dateList = res.day_acc_list;
    },
    ...mapActions([])
  },
  computed: {
    ...mapGetters([]),
    acc_list_sort() {
      let acc_list = this.$_.cloneDeep(this.acc_list);
      acc_list.forEach(a => {
        let { dish_acc_info_list } = a;
        a.dish_acc_info_list = this.$_.orderBy(
          dish_acc_info_list,
          "dish_acc",
          "desc"
        );
      });
      return this.$_.orderBy(
        acc_list,
        a => Number(this.$_.last(a.dish_acc_info_list).dish_acc),
        "acs"
      );
      // acc_list;
      // return this.acc_list();
    },
    acc_list() {
      let dateList = this.$_.cloneDeep(this.dateList);
      let res = dateList.map(a => {
        let day_ts = a.day_ts;
        let dish_acc_canteen_list = a.dish_acc_canteen_list;
        return dish_acc_canteen_list.map(b => {
          this.$set(b, "day_ts", day_ts);
          return b;
        });
      });
      return this.$_.flatten(res);
    },
    dateRank() {
      let dateRange = this.dateRange;
      // 当天0点的时间戳
      const end_ts = util.dateToUnixtimestamp(dateRange[1], 0);
      const [a, b] = dateRange.map(a => moment(a));
      return {
        end_day_ts: end_ts,
        recently_days: b.diff(a, "days") + 1
      };
    }
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
.container {
  .header {
    top: -40px;
    .active {
      color: #000;
    }
  }
  .chart-item {
    height: 400px;
  }
}
</style>
